import React, { useEffect, useState, useRef } from "react";
import { getInfo } from "@/api/OrderReview/index";
import { getFileUrl } from "@/utils/FileUtil";
import {  useLocation } from "react-router-dom";
import { WechatFilled } from "@ant-design/icons";
import {  Spin, Image } from "antd";
import Iconfont from "@/components/Icon/IconFont";
import ContactPhoneModal from "@/components/ContactPhoneModal";
import { translateBusinessType } from "@/utils/productUtils";
import { formatPhoneNumber } from "@/utils/formatVal";
import CountryAreaTags from "@/components/CountryAdress/CountryAreaTags";
import "./index.less";

const OpportunityClues = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');
  const [infoData, setInfoData] = useState({});
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);

 

  const handleIphoneCancel = () => {
    setModalVisible(false);
  };
  useEffect(() => {
    const fetchInfo = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const res = await getInfo({ id: id });
        if (res?.code === "0") {
          const data = res?.data || {};
          setInfoData(data);

          const imageObjects = [];

          if (data.coverImg) {
            try {
              const coverImgArray = Array.isArray(data.coverImg)
                ? data.coverImg
                : JSON.parse(data.coverImg);

              imageObjects.push(
                ...coverImgArray.map((img) => img.filePath || img.url)
              );
            } catch (e) {
              console.warn("解析coverImg失败:", e);
            }
          }

          if (data.fileInfos) {
            try {
              const mainImgArray = Array.isArray(data.fileInfos)
                ? data.fileInfos
                : JSON.parse(data.fileInfos);

              imageObjects.push(
                ...mainImgArray.map((img) => img.filePath || img.url)
              );
            } catch (e) {
              console.warn("解析mainImgUrl失败:", e);
              imageObjects.push(
                ...data.fileInfos.split(",").filter((url) => url.trim())
              );
            }
          }

          const uniqueImageUrls = [...new Set(imageObjects)].filter(
            (url) => url && url.trim()
          );

          if (uniqueImageUrls.length > 0) {
            const imageUrlString = uniqueImageUrls.join(",");
            const processedImages = await processImageUrls(imageUrlString);
            if (processedImages.length > 0) {
              setImages(processedImages);
              setSelectedImage(processedImages[0]);
            }
          } else {
            setImages([]);
            setSelectedImage(null);
          }
        }
      } catch (error) {
        console.error("请求出错:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInfo();
  }, [id]);

  const processImageUrls = async (imageUrlsString) => {
    if (!imageUrlsString) return [];

    const urls = imageUrlsString.split(",");
    const processedImages = [];

    for (let i = 0; i < urls.length; i++) {
      const trimmedUrl = urls[i].trim();
      try {
        const fullUrl = await getFileUrl(trimmedUrl);
        processedImages.push({
          id: i + 1,
          src: fullUrl,
          thumb: fullUrl,
          alt: `产品图片 ${i + 1}`,
        });
      } catch (error) {
        console.error("处理图片URL出错:", error);
        processedImages.push({
          id: i + 1,
          src: trimmedUrl,
          thumb: trimmedUrl,
          alt: `产品图片 ${i + 1}`,
        });
      }
    }

    return processedImages;
  };
  const handleImageSelect = (image) => {
    setSelectedImage(image);
  };

  return (
    <Spin spinning={loading} size="large" wrapperClassName="demand-detail-spin">
      <div className="opportunity-clues">
        <div className="container-home-page">
          <div className="detail-container">
            <div className="detail-content">
              <div className="opportunity-card">
                <div className="card-header">
                  <h1 className="opportunity-title">
                    {infoData?.productTitle}
                  </h1>
                  <div className="opportunity-meta">
                    <div className="meta-item">
                      <Iconfont icon="faTag" />
                      <span>
                        {translateBusinessType(
                          infoData.businessOpportunityType
                        )}
                      </span>
                    </div>
                    <div className="meta-item">
                      <Iconfont icon="faMapMarkerAlt" />
                      {/* <span>{infoData?.supplyArea}</span> */}
                        <CountryAreaTags value={infoData?.producingAreas} />
                    </div>
                    <div className="meta-item">
                      <Iconfont icon="faClock" />
                      <span>发布于{infoData?.createTime}</span>
                    </div>
                    <div className="meta-item">
                      <Iconfont icon="faCalendarAlt" />
                      <span>有效期：{infoData?.businessPeriod}</span>
                    </div>
                  </div>
                  
                  <div className="opportunity-meta">
                    <div className="tag">
                    {translateBusinessType(infoData.businessOpportunityType)}
                  </div>
                    {infoData?.businessCode ? (
                      <div className="tag">
                        业务编码： {infoData?.businessCode}
                      </div>
                    ) : null}
                    {/* {infoData?.producingAreas ? (
                      <div className="tag">
                        所在地：
                        <CountryAreaTags value={infoData?.producingAreas} />
                      </div>
                    ) : null} */}
                  </div>
                </div>

                <div className="card-body">
                  <div className="section-cont">
                    <h3 className="section-label">
                      <Iconfont icon="faImages" /> 商品主图
                    </h3>
                    <div className="main-image">
                      <Image
                        wrapperStyle={{
                          width: "100%",
                          height: "400px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f5f5f5",
                        }}
                        style={{
                          objectFit: "contain",
                          maxWidth: "100%",
                          maxHeight: "100%",
                          width: "auto",
                          height: "auto",
                        }}
                        src={selectedImage?.src || ""}
                        alt={selectedImage?.alt || ""}
                      />
                    </div>
                    <div className="image-thumbnails">
                      {images.map((image) => (
                        <div
                          key={image.id}
                          className={`thumbnail ${
                            selectedImage.id === image.id ? "active" : ""
                          }`}
                          onClick={() => handleImageSelect(image)}
                        >
                          <img src={image.thumb} alt={image.alt} />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="section-cont">
                    <h3 className="section-label">
                      <Iconfont icon="faInfoCircle" /> 商机线索描述
                    </h3>
                    <div className="section-content">
                      <p>{infoData?.productDesc}</p>
                    </div>
                  </div>

                  <div className="section-cont">
                    <h3 className="section-label">
                      <Iconfont icon="faHandshake" /> 合作需求
                    </h3>
                    <div className="section-content">
                      <p>{infoData?.cooperationDesc}</p>
                    </div>
                  </div>

                  <div className="section-cont">
                    <h3 className="section-label">
                      <Iconfont icon="faChartLine" />
                      市场前景
                    </h3>
                    <div className="section-content">
                      <p>{infoData?.marketProspectDesc}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-card">
                <h3 className="contact-label">联系发布方</h3>

                <div className="contact-info">
                  <div className="contact-item">
                    <i>
                      <Iconfont icon="faUser" />
                    </i>
                    <div className="contact-detail">
                      <div className="contact-label">联系人</div>
                      <div className="contact-value">{infoData?.contact}</div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <i>
                      <Iconfont icon="faPhone" />
                    </i>
                    <div className="contact-detail">
                      <div className="contact-label">联系电话</div>
                      <div className="contact-value">
                        {infoData?.phoneNum
                          ? formatPhoneNumber(infoData.phoneNum)
                          : "未提供"}
                      </div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <i>
                      <Iconfont icon="faEnvelope" />
                    </i>
                    <div className="contact-detail">
                      <div className="contact-label">电子邮箱</div>
                      <div className="contact-value">{infoData?.email}</div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <i style={{ fontSize: 19,color: "#1677ff" }}>
                      <WechatFilled />
                    </i>
                    <div className="contact-detail">
                      <div className="contact-label">微信</div>
                      <div className="contact-value">
                        {infoData?.otherContact}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="company-info">
                  <h4 className="company-title">{infoData?.compName}</h4>
                  <div className="company-description">
                    {infoData?.compDesc}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ContactPhoneModal
          phoneNUm={infoData?.phoneNum}
          onCancel={handleIphoneCancel}
          modalVisible={modalVisible}
        />
      </div>
    </Spin>
  );
};
export default OpportunityClues;
